module.exports = __webpack_public_path__ + "static/img/pic.8f5504d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/video/pic.png
// module id = 1714
// module chunks = 2